module.exports = __webpack_public_path__ + "img/money-1.7c5aaa66.png";